import { useQuery } from "@tanstack/react-query";
import { instance } from "../../axios.config";

export const useAboutUs = (params) => {
  return useQuery({
    queryKey: ["aboutUs", params],
    queryFn: async () => {
      const { data } = await instance.get("about-us", { params });
      return data;
    },
  });
};

export const useFooterLayouts = (params) => {
  return useQuery({
    queryKey: ["footerLayouts", params],
    queryFn: async () => {
      const { data } = await instance.get("layouts", { params });
      return data;
    },
  });
};

export const useRules = () => {
  return useQuery({
    queryKey: ["rules"],
    queryFn: async () => {
      const { data } = await instance.get("rules");
      return data;
    },
  });
};

export const usePrivacies = () => {
  return useQuery({
    queryKey: ["privacies"],
    queryFn: async () => {
      const { data } = await instance.get("privacies");
      return data;
    },
  });
};

export const useFaqs = () => {
  return useQuery({
    queryKey: ["faqs"],
    queryFn: async () => {
      const { data } = await instance.get("faqs");
      return data;
    },
  });
};

export const useSlideShows = () => {
  return useQuery({
    queryKey: ["slideShows"],
    queryFn: async () => {
      const {
        data: { data },
      } = await instance.get("slideshows");
      return data;
    },
  });
};
